import React from 'react';

const ClientContext = React.createContext();

export default ClientContext;
